import styled from 'styled-components';
import { colors } from 'constants/theme';
import MEDIA from 'helpers/mediaTemplates';
export const TitleHeader = styled.div.withConfig({
  displayName: "filtercss__TitleHeader",
  componentId: "sc-1e7wnea-0"
})(["display:inline-flex;align-items:baseline;justify-items:space-between;width:100%;justify-content:space-between;"]);
export const Categories = styled.div.withConfig({
  displayName: "filtercss__Categories",
  componentId: "sc-1e7wnea-1"
})(["padding:12px;", " border-radius:12px;background:", ";a{text-decoration:none;color:", ";&:hover{color:inherit;}}a:not(:first-child){margin-left:1.5rem;}a.active{font-weight:bold;}"], MEDIA.PHONE`
    padding: 8px;
  `, colors.lightestGrey, colors.darkGrey);
export const Counter = styled.span.withConfig({
  displayName: "filtercss__Counter",
  componentId: "sc-1e7wnea-2"
})(["display:block;text-align:right;color:", ";font-size:1rem;"], colors.darkGrey);